var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fields"},[_c('Toolbox'),_c('Design'),_c('Property')],1)}
var staticRenderFns = []

export { render, staticRenderFns }